import React from "react"
import { Tooltip, TooltipProps as MantineTooltipProps } from "@mantine/core"
import { TooltipProps } from "@mui/material"
import withMappedProps from "hoc-lib/propsMapping"

export const MantineTooltip = Tooltip

export default MantineTooltip

const muiToMantine = (props: TooltipProps): MantineTooltipProps => ({
  ...props,
  label: props.title,
  title: undefined,
  position: props.placement,
  withArrow: props.arrow,
  openDelay: props.enterDelay,
  closeDelay: props.leaveDelay,
})

export const MUIMappedTooltip = withMappedProps(MantineTooltip, muiToMantine)
